import { render, staticRenderFns } from "./OptionNote.vue?vue&type=template&id=1d9fcf82&scoped=true"
import script from "./OptionNote.vue?vue&type=script&lang=js"
export * from "./OptionNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9fcf82",
  null
  
)

export default component.exports